<div class="modal fade" id="add-to-jiocloud-modal" role="dialog" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': showAddToAlbumModal ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      <div class="modal-header">
        @if (!this.listService.createAlbumObject) {
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }
        <div class="container pl-1 pr-1 mt-1">
          <div class="row">
            <div class="col-10">
              <span class="NeueBack float-left" (click)="closePopUp()"></span>
              <h5>Add to Album</h5>
            </div>
            <div class="col-2 text-right">
              <div class="icon-toggle">
                @if (selectedTab?.name == 'My Albums') {
                  <span class="Neueaddfilefilled" title="Create new album" data-toggle="modal" (click)="createAlbum();"></span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-body">
        @if (showAddToAlbumModal) {
          <lib-pop-up-tabbed-view/>
        }
        <div class="add-to-jiocloud-content">
          <div class="addtoJioCloud addToJioCloudAlbumCont">
            <div role="tabpanel" class="tab-pane pt-2" id="myalbums">
              <div class="my-albums-content pb-3 pl-0 mt-2 pt-1">
                @if (this.listService.noAlbumsPresent) {
                  <div class="no-folders-add-to-jiocloud">
                    @if (selectedTab.name == 'My Albums') {
                      <div class="msg-txt">
                        <h1>No Albums found!</h1>
                        <p>Albums created by you will show here.</p>
                        <p>Create a New Album to add files.</p>
                      </div>
                    }
                    @if (selectedTab.name == 'Shared Albums') {
                      <div class="msg-txt">
                        <h1>No Albums found!</h1>
                        <p>Albums shared by you or shared with you will show here.</p>
                      </div>
                    }
                    <img src="https://static.jiocloud.com/ng/images/inapp_16_2x.png" class="img-fluid" />
                  </div>
                }
                <div class="row text-lg-left image-thumb-gallery">
                  @for (album of albumsList; track album; let i = $index) {
                    <div class="col-md-4 col-6 pl-0 pr-2 ml-0 mr-0 flex-cont">
                      <div class="gridItem grid_file_child thumb-img-holder">
                        <label class="check-wrap">
                          <span class="checkmark thumb-checkmark"></span>
                        </label>
                        <div class="img-thumbnail-cont" id="imgCont_{{i}}" (click)="this.selectPhoto($event,album)">
                          <div class="photo-card" id="{{album.FullObject.boardKey}}">
                            @if (album?.FullObject?.isShareAlbum && album?.FullObject?.boardMembers) {
                              <div class="avatars">
                                @for (member of album.FullObject?.boardMembers; track member) {
                                  <span class="avatar" title="{{member?.firstName}} {{member?.lastName}}">
                                    <span class="icon-profile-holder mr-2" >{{getNameInitailChar(member.firstName,member.lastName)}}</span>
                                    <img src="{{member.profilePic}}" (error)="thumbnailError($event)" alt="" class="img-fluid">
                                  </span>
                                }
                              </div>
                            }
                          </div>
                          <img draggable="false" class="img-fluid img-thumbnail" src="{{album.ImagePath}}" onerror="this.src='assets/images/default_board_cover_pic.svg';this.classList.add('defaultImg')" alt="">
                          <!-- <img draggable="false" class="img-fluid img-thumbnail" src="https://static.jiocloud.com/web2.0/common/images/mob_view.png" onerror="this.src='assets/images/default_board_cover_pic.svg';this.classList.add('defaultImg')" alt=""> -->
                        </div>
                        <span class="NeueMore_Options m-more-options" (click)="this.universalService.openMobileOptionMenu(this.universalService.selectedFile)"></span>
                        <h6 title="{{album.fileName}}">{{album.fileName}}</h6>
                        <p>
                          @if (album.FullObject?.filesCount == 1) {
                            <span >{{album.FullObject?.filesCount}} item</span>
                          }
                          @if (album.FullObject?.filesCount > 1 || album.FullObject?.filesCount == 0) {
                            <span >{{album.FullObject?.filesCount}} items</span>
                          }
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="add-btn-main">
          <button (click)="addToAlbum()" [disabled]="!this.universalService.objectSelected" class="btn ripple-fx">Add Here</button>
        </div>
      </div>
    </div>

  </div>
</div>

@if (showAddToAlbumModal) {
  <lib-create-album [enableButton]="enableButton" (closecreateModal)="closeCreateModal()" (createAlbumValidation)="validateBeforeCreatingAlbum($event)" (createAlbum)="createAlbumAndAdd()" (goback)="goBackToPreviousScreen()"/>
}
